// extracted by mini-css-extract-plugin
export default {"logsText":"logs-tab-label_logsText__KZ6D9"};